






































































  import ImagePickerView from "@/views/ImagePickerView.vue";
  import Vue from 'vue';
  import {DonationImage} from "@/interfaces/donation/donationImage";

  export default Vue.extend({
    components: { ImagePickerView },
    props: {
      value: {
        type: Number,
        default: null,
      },
      label: {
        type: String,
        default: null,
      },
      hint: {
        type: String,
        default: null,
      },
      images: {
        type: Array,
        default: null,
      },
      categories: {
        type: Array,
        default: null,
      },
      showLazy: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        dialog: false,
        loading: false,
        imageId: this.value,
      };
    },
    // todo - image needs an interface or class
    computed: {
      imageUrl() {
        const image:DonationImage = this.images.find(i => i.id === this.imageId);
        return image && image.url;
      },
    },
    watch: {
      imageId: {
        handler(val)
        {
          if (val) {
            this.$emit('input', val);
          }
        },
        immediate: true
      },
    },
    methods: {
      random() {
        this.loading = true
        const newId = this.images[Math.floor(Math.random() * this.images.length)].id;
        if (newId != this.imageId) {
          this.imageId = newId;
        } else {
          this.random();
        }
        this.loading = false
      },
    },
  });
